export enum DatabaseEventType {
    ADDED,
    EDITED,
    ARCHIVED,
    SOLUTION_OPTIMISED,
    BULK_EDITED,
    USER_CHANGED,
    DIVISIONS_SYNCRONIZED,
}
export enum DatabaseResource {
    ANY,
    EXISTING_LUMINAIRE,
    MODEL_VARIANT,
    FITTING,
    SPECIAL_REQUIREMENT,
    EMERGENCY_METHOD,
    CONTROL_TYPE,
    TECHNOLOGY,
    WIRING_INSTALLATION,
    CEILING_FIXING,
    ACCESS_TYPE,
    MANUFACTURER,
    SENSOR,
    PROJECT,
    PROPOSED_LUMINAIRE,
    USER,
    MODEL,
    MODEL_PROJECT_INFO,
    MODEL_SPECIFICATION_AND_CONTRACT,
    MODEL_BURN_GROUPS,
    MODEL_SOLUTION_MODELING,
    MODEL_AREA_ZONE_LOCATION,
    PROPOSALS,
    PROPOSALS_TEMPLATES,
    PROJECT_COSTS,
    VARIABLES,
    DIVISIONS,
    INDEX_AND_SCALARS,
}

export interface DatabaseEvent {
    resource: DatabaseResource;
    type: DatabaseEventType;
    data?: any;
}
